const packetState = {
  indexing: [],
  attributesArray: [],
  trackingCodeStatus: [],
  additionalDetailsEdit: false
};

export default packetState;
